/**
 * Family B — renders children only in proof/diagnostics/audit mode.
 * Operator default surfaces must not mount proof chrome.
 */
import React from 'react';
import type { OperatorSurfaceClassV0 } from '../types/OperatorProofSurfaceSeparationV0';

export interface OperatorProofModeGateV0Props {
  surfaceClass: OperatorSurfaceClassV0;
  /** When true, also allow audit_drawer content under surfaceClass=audit */
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export function OperatorProofModeGateV0({
  surfaceClass,
  children,
  fallback = null,
}: OperatorProofModeGateV0Props): React.ReactElement | null {
  const allowed =
    surfaceClass === 'proof' || surfaceClass === 'diagnostics' || surfaceClass === 'audit';
  if (!allowed) {
    return fallback ? <>{fallback}</> : null;
  }
  return (
    <div data-operator-surface-class={surfaceClass} data-proof-mode-gate="open">
      {children}
    </div>
  );
}
